/**
 * Site APIs
 * APIs for content management
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Model1 } from './model1';


export interface Event { 
    archived?: boolean;
    createdAt?: string;
    description?: string;
    eventDate?: string;
    eventEndDate?: string;
    eventImageFive?: string;
    eventImageFour?: string;
    eventImageOne?: string;
    eventImageThree?: string;
    eventImageTwo?: string;
    /**
     * Daily, Weekly, Monthly, Yearly, NoRecursion
     */
    eventRecursion?: string;
    eventWeekDays?: Model1;
    id?: string;
    importObjectKey?: string;
    importSessionKey?: string;
    intro?: string;
    isAllDay?: boolean;
    isFeatured?: boolean;
    isMerchant?: boolean;
    location?: string;
    locked?: boolean;
    path?: string;
    pdf?: string;
    price?: number;
    published?: boolean;
    readOnly?: boolean;
    repeatEvery?: number;
    subTitle?: string;
    ticketLink?: string;
    title?: string;
    /**
     * free, paid
     */
    type?: string;
    updatedAt?: string;
    version?: number;
    youtubeEmbedLink?: string;
}
